
import { RuleTypeEnum } from "../../../domain/RuleType";
import { EnrichedYoutubeTopicRuleValue } from "../../../domain/ruleValue/YoutubeTopicRuleValue";
import { RuleValueStore, SerializedRuleValueStore } from "../RuleValueStore";

export class YoutubeTopicRuleValueStore implements RuleValueStore<RuleTypeEnum.YOUTUBE_TOPIC> {
    allowedTopicSlugs: Set<string>;
    deniedTopicSlugs: Set<string>;

    constructor() {
        this.allowedTopicSlugs = new Set();
        this.deniedTopicSlugs = new Set();
    }

    add(enrichedRuleValue: EnrichedYoutubeTopicRuleValue): void {
        if (enrichedRuleValue.action.isAllow()) {
            for (const slug of enrichedRuleValue.slugs) {
                this.allowedTopicSlugs.add(slug.getValue());
            }
        } else {
            for (const slug of enrichedRuleValue.slugs) {
                this.deniedTopicSlugs.add(slug.getValue());
            }
        }
    }

    serialize(): SerializedRuleValueStore<RuleTypeEnum.YOUTUBE_TOPIC> {
        const data: SerializedYoutubeTopicRuleValueStoreData = {
            allowedTopicSlugs: Array.from(this.allowedTopicSlugs),
            deniedTopicSlugs: Array.from(this.deniedTopicSlugs),
        };
        return {
            type: RuleTypeEnum.YOUTUBE_TOPIC,
            data: data,
        };
    }

    fromSerialized(serialized: SerializedRuleValueStore<RuleTypeEnum.YOUTUBE_TOPIC>): void {
        this.allowedTopicSlugs = new Set(serialized.data.allowedTopicSlugs);
        this.deniedTopicSlugs = new Set(serialized.data.deniedTopicSlugs);
    }

    evaluateYoutubeTopic(topicSlugs: string[]): YoutubeTopicRuleValueStoreEvaluationResult {
        // Check whitelist
        for (const topicSlug of topicSlugs) {
            if (this.allowedTopicSlugs.has(topicSlug)) return "ALLOWED";
        }

        // Check blacklist
        for (const topicSlug of topicSlugs) {
            if (this.deniedTopicSlugs.has(topicSlug)) return "DENIED";
        }

        return "NO_MATCH";
    }
}

export interface SerializedYoutubeTopicRuleValueStoreData {
    allowedTopicSlugs: string[];
    deniedTopicSlugs: string[];
};

export type YoutubeTopicRuleValueStoreEvaluationResult = "ALLOWED" | "DENIED" | "NO_MATCH"